const colors = require('./colors');
const { spaces, spacesWithUnit, spacesByAliases } = require('./space');
const breakpoints = require('./breakpoints');

/* TODO: include somewhere
 * only shadows supported for now
 */
// boxShadows
const boxShadows = [
  `0 0 2px 0 rgba(0,0,0,.08),0 1px 4px 0 rgba(0,0,0,.16)`,
  `0 0 2px 0 rgba(0,0,0,.08),0 2px 8px 0 rgba(0,0,0,.16)`,
  `0 0 2px 0 rgba(0,0,0,.08),0 4px 16px 0 rgba(0,0,0,.16)`,
  `0 0 2px 0 rgba(0,0,0,.08),0 8px 32px 0 rgba(0,0,0,.16)`,
];

// animation duration
const duration = {
  fast: `150ms`,
  normal: `300ms`,
  slow: `450ms`,
  slowest: `600ms`,
};

// animation easing curves
const easeInOut = 'cubic-bezier(0.5, 0, 0.25, 1)';
const easeOut = 'cubic-bezier(0, 0, 0.25, 1)';
const easeIn = 'cubic-bezier(0.5, 0, 1, 1)';

const timingFunctions = {
  easeInOut,
  easeOut,
  easeIn,
};

// animation delay
const transitionDelays = {
  small: `60ms`,
  medium: `160ms`,
  large: `260ms`,
  xLarge: `360ms`,
};

/**
 * Read this first!
 * fields with "_" contains values of the fields without unit.
 *
 * e.g. _space contains all the same value as in space but without px suffix.
 * _space === [0, 4, 8, ...] while space === ['0px', '4px', '8px']
 *
 * Therefore if you want to calculate something, use "_space", if not, use "space"
 */

const fontSizes = [12, 14, 16, 18, 20, 24, 28, 34, 48, 60, 96];
const fontWeights = {
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

const lineHeights = {
  mainTitle: 1.15,
  elementTitle: 1.2,
  subElementTitle: 1.3,
  emphasisText: 1.43,
  normal: 1.5,
};

const letterSpacings = {
  thinner: -0.35,
  thin: -0.25,
  default: 'normal',
  normal: 0.1,
  wide: 0.2,
  wider: 0.5,
};

const theme = {
  breakpoints: breakpoints.map((b) => `${b}px`),
  breakpointsAliases: ['sm', 'md', 'lg'],

  // FIXME: legacy breakpoints without 'px'
  _breakpoints: breakpoints,

  space: spaces,
  spaceAliases: ['none', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl', 'xxxxl'],

  // _space: spaces,
  fontSizes,
  fontWeights,
  lineHeights: lineHeights,
  letterSpacings,
  fonts: {
    contentReadable: 'Sarabun, sans-serif',
    content: 'Rubik, Anuphan, sans-serif',
    serif: 'athelas, georgia, times, serif',
    // sansSerif: BS4_NATIVE_FONT_STACK,
    sans: 'Noto Sans, Noto Sans Thai, sans-serif',
    // mono: 'Pridi, Menlo, monospace',
  },
  borders: [0, '1px solid', '2px solid', '4px solid', '8px solid', '16px solid', '32px solid'],
  radii: [0, 2, 4, 16, 9999, '100%'],

  duration,
  timingFunctions,
  transitionDelays,

  // TODO: Beware of affecting some components.
  // shadows: boxShadows,
  colors,

  textStyles: {
    heading1: {
      fontSize: fontSizes[8],
      fontWeight: fontWeights.normal,
      letterSpacing: letterSpacings.thinner,
      lineHeight: lineHeights.mainTitle,
    },
    heading2: {
      fontSize: fontSizes[7],
      fontWeight: fontWeights.semibold,
      letterSpacing: letterSpacings.thin,
      lineHeight: lineHeights.emphasisText,
    },
    heading3: {
      fontSize: fontSizes[6],
      fontWeight: fontWeights.semibold,
      letterSpacing: letterSpacings.thin,
      lineHeight: lineHeights.mainTitle,
    },
    heading4: {
      fontSize: fontSizes[5],
      fontWeight: fontWeights.semibold,
      letterSpacing: letterSpacings.default,
      lineHeight: lineHeights.mainTitle,
    },
    heading5: {
      fontSize: fontSizes[4],
      fontWeight: fontWeights.semibold,
      letterSpacing: letterSpacings.default,
      lineHeight: lineHeights.mainTitle,
    },
    subtitle1: {
      fontSize: fontSizes[3],
      fontWeight: fontWeights.semibold,
      letterSpacing: letterSpacings.normal,
      lineHeight: lineHeights.mainTitle,
    },
    body1: {
      fontSize: fontSizes[2],
      fontWeight: fontWeights.normal,
      letterSpacing: letterSpacings.normal,
      lineHeight: lineHeights.subElementTitle,
    },
    body1Medium: {
      fontSize: fontSizes[2],
      fontWeight: fontWeights.semibold,
      letterSpacing: letterSpacings.normal,
      lineHeight: lineHeights.subElementTitle,
    },
    body2: {
      fontSize: fontSizes[1],
      fontWeight: fontWeights.light,
      letterSpacing: letterSpacings.wide,
      lineHeight: lineHeights.emphasisText,
    },
    caption: {
      fontSize: fontSizes[0],
      fontWeight: fontWeights.light,
      letterSpacing: letterSpacings.wider,
      lineHeight: lineHeights.elementTitle,
    },
    xxs: {
      fontSize: 10,
      fontWeight: fontWeights.normal,
      letterSpacing: letterSpacings.wide,
      lineHeight: lineHeights.emphasisText,
    },
  },
};

module.exports = {
  COLOR: colors,
  boxShadows,
  duration,
  theme,

  // There're ES default imports - to make sure it won't break
  default: theme,

  // @deprecated
  // no need for direct import e.g. SPACE.md
  // will use key alias instead
  SPACE: spacesByAliases,

  // This is a workaround to export spaces without units.
  // spacesByAliases should be removed from export later since all spaces should be referenced from theme.
  SPACES: spaces,
  BREAKPOINTS: breakpoints,
};
